/**
 *  实现功能
 *  1、默认情况下只禁止空格输入
 *  2、限制只能输入整数
 *  3、限制只能输入整数和小数（价格类）
 *  4、限制只能输入手机号
 *  5、限制最大值和最小值(抛出错误给回调函数)
 */
const addListener = function (el, type, fn) {
  el.addEventListener(type, fn, false)
}
const spaceFilter = function (el) {
  addListener(el, 'keyup', () => {
    el.value = el.value.replace(/\s+/g, '')
  })
}

export default {
  bind (el, binding, vnode) {
    if (el.tagName.toLowerCase() !== 'input') {
      el = el.getElementsByTagName('input')[0]
    }
    spaceFilter(el)
    switch (binding.arg) {
      // case 'space':
      //   intFilter(el)
      //   break
      // default:
      //   break
    }
  }
}
